import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import NavTagline from "../nav-tagline/nav-tagline";
import CallAPI from "../../services/apiCalls";
import Footer from "../shared/Footer";
import useUserStore from "../../utils/storeApp";

const ExperianResults = () => {
    const [processing, SetProcessing] = useState(false);
    const [searchParams] = useSearchParams();
    const { userToken } =
        useUserStore((state) => ({
            userToken: state.userToken
        }));

    useEffect(() => {

        const initialize = async () => {
            SetProcessing(true);

            const foundResult = searchParams.get("result");

            let call = "/experian/ExperianResult?result=" + foundResult;
            const res = await CallAPI(call, false, "POST", userToken);

            SetProcessing(false);
        };

        initialize();
    }, []);
    const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
  let timer;
  if (processing) {
    timer = setTimeout(() => {
      setLoadingText("Working on it...");
    }, 10000);
  } else {
    setLoadingText("Loading...");
  }

  return () => clearTimeout(timer); 
  }, [processing]);

    return (
        <>
            {processing ? (
                <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="experian-results-loader"
                >
                    <div className="spinner" aria-hidden="true"></div>
                    <div className="loading-text" id="experian-results-loader">{loadingText}</div>
                </div>
            ) : (
                <div className="ExperianResults">
                    <NavTagline />
                    <section className="layout-container" aria-labelledby="experianResultsHeading">
                        <div className="container ctr">
                            <div className="text-size3 or-clr"><i className="bi bi-clock-history" aria-hidden="true"></i></div>
                            <h1 className="text-size5 or-clr" id="experianResultsHeading">Almost Ready! </h1>
                            <p className="text-size4 sp-margin10">An Enrollment Specialist will be in contact with you shortly to complete setting up your account. </p>
                                <p className="text-size9 sp-margin10">If you need immediate support, please email CHS Enrollment at <a href="mailto:enrollment@secureexsolutions.com" aria-label="Email CHS Enrollment at enrollment@secureexsolutions.com">enrollment@secureexsolutions.com</a>{" "} or call{" "}
                                    <a
                                    href="tel:18884709913,1"
                                    aria-label="Call 1-888-470-9913 extension 1"
                                >
                                    1.888.470.9913 ext 1
                                    </a>.
                                </p>
                        </div>
                    </section>
                    <Footer />
                </div>
            )}
        </>
    );
};

export default ExperianResults;